export default {
  search_header_v4: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    },
  },
  apparel_header_v4: {
    flags: {
      test: .5,
      control: .5
    },
  },
  ttarp_test_v2: {
    flags: {
      test: 0.5,
      control: 0.5
    },
  },
};
